<template>
    <div id="liste_scores" class="popin-modal centered" v-bind:class="{ 'active': isPopinLoaded }"
        v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_listescoresDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_listescoresClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin-closure-responsive" v-on:click="popin_listescoresClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div v-bind:class="{ 'popin-content': true, 'loaded': isPopinLoaded }">
                    <template v-if="isPopinLoaded">
                       <div class="popin-content-container" v-bind:class="bindClass_popinContentContainer()">
                            <div class="banniere">
                                <div class="logo-lockquest"></div>
                                <div class="logo-room"></div>
                                <div class="scores-links">
                                    <span v-if="scenario_slug !== 'le-tombeau-de-siptah'" 
                                        v-on:click="display_listeScores('le-tombeau-de-siptah')">> Le tombeau de Siptah</span>
                                    <span v-if="scenario_slug !== 'le-secret-de-mayoko'" 
                                        v-on:click="display_listeScores('le-secret-de-mayoko')">> Le secret de Mayoko</span>
                                    <span v-if="scenario_slug !== 'les-gardiens-de-vichama'" 
                                        v-on:click="display_listeScores('les-gardiens-de-vichama')">> Les gardiens de Vichama</span>
                                    <span v-if="scenario_slug !== 'le-talisman-des-titans'" 
                                        v-on:click="display_listeScores('le-talisman-des-titans')">> Le talisman des titans</span>
                                    <span v-if="scenario_slug !== 'la-legende-d-ishtar'" 
                                        v-on:click="display_listeScores('la-legende-d-ishtar')">> La légende d'Ishtar</span>
                                </div>
                            </div>
                            <div class="latest-score">
                                <div>
                                    <span>Date</span><!--
                                    --><span>Rang</span><!--
                                    --><span>Équipe</span><!--
                                    --><span>Temps</span><!--
                                    --><span>Indices</span><!--
                                    --><span>Score</span><!--
                                    --><span>&nbsp</span>
                                </div>
                                <div v-if="latest_room_session">
                                    <span>{{ latest_room_session.session_time.day }}/{{latest_room_session.session_time.month }}</span><!--
                                    --><span>{{ latest_room_session.rank }}</span><!--
                                    --><span>{{ latest_room_session.team_name }}</span><!--
                                    --><span>
                                        <template v-if="latest_room_session.results_time.raw >= 3600">{{ latest_room_session.results_time.hours }}:</template><!--
                                        --><template>{{ latest_room_session.results_time.minutes }}:{{ latest_room_session.results_time.seconds }}</template>
                                        <span class="results-time-locked" v-if="!latest_room_session.results_success">&nbsp</span>
                                    </span><!--
                                    --><span>{{ latest_room_session.results_clues }}</span><!--
                                    --><span>{{ latest_room_session.score }}</span><!--
                                    --><span class="game-mode-decouverte" v-if="latest_room_session.game_mode == 'decouverte'">&nbsp;</span><!--
                                    --><span class="game-mode-confirme" v-else-if="latest_room_session.game_mode == 'confirme'">&nbsp;</span><!--
                                    --><span v-else>&nbsp;</span>
                                </div>
                            </div>
                            <div class="liste-scores" v-if="room_sessions">
                                <div v-for="room_session in room_sessions" 
                                    v-bind:class="{ 'first': room_session.rank == 1, 'second': room_session.rank == 2, 'third': room_session.rank == 3 }">
                                    <span>{{ room_session.session_time.day }}/{{room_session.session_time.month }}</span><!--
                                    --><span>{{ room_session.rank }}</span><!--
                                    --><span>{{ room_session.team_name }}</span><!--
                                    --><span>
                                        <template v-if="room_session.results_time.raw >= 3600">{{ room_session.results_time.hours }}:</template><!--
                                        --><template>{{ room_session.results_time.minutes }}:{{ room_session.results_time.seconds }}</template>
                                        <span class="results-time-locked" v-if="!room_session.results_success">&nbsp</span>
                                    </span><!--
                                    --><span>{{ room_session.results_clues }}</span><!--
                                    --><span>{{ room_session.score }}</span><!--
                                    --><span class="game-mode-decouverte" v-if="room_session.game_mode == 'decouverte'">&nbsp;</span><!--
                                    --><span class="game-mode-confirme" v-else-if="room_session.game_mode == 'confirme'">&nbsp;</span><!--
                                    --><span v-else>&nbsp;</span>
                                </div>
                            </div>
                       </div>
                    </template>
                    <template v-else>
                        <Loader />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import Loader from './Loader.vue';

import anime from 'animejs/lib/anime.es';
import axios from 'axios';

export default {
    name: "ListeScores",
    components: {
        Loader
    },
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        isPopinLoaded: false,
        // scores informations
        scenario_slug: null,
        destinations_and_rooms: {
            'le-tombeau-de-siptah': 'room_1',
            'le-secret-de-mayoko': 'room_2',
            'les-gardiens-de-vichama': 'room_3',
            'le-talisman-des-titans': 'room_4',
            'la-legende-d-ishtar': 'room_5'
        },
        room_sessions: null,
        latest_room_session: null
    }),
    methods: {
        popin_listescoresDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            this.isPopinLoaded = true;

            var self = this;
            Vue.nextTick(function() {
                axios.get('https://api.lockquest.fr/room_sessions?nb_items=50&room=room_1')
                .then((response) => {
                    self.room_sessions = response.data;
                    self.latest_room_session = self.room_sessions.shift();
                });
            });
        },
        popin_listescoresDisplayed: function(scenario_slug) {
            this.scenario_slug = scenario_slug;
            this.isPopinDisplayed = true;
        },
        popin_listescoresClosed: function(event) {
            this.isPopinDisplayed = false;
            this.isPopinLoaded = false;

            this.scenario_slug = null;
        },
        bindClass_popinContentContainer: function() {
            var obj = {};
            obj[this.scenario_slug] = true;

            return obj;
        },
        display_listeScores: function(scenario_slug) {
            this.scenario_slug = scenario_slug;
            this.room_sessions = null;
            this.latest_room_session = null;

            var self = this;
            axios.get('https://api.lockquest.fr/room_sessions?nb_items=50&room=' + this.destinations_and_rooms[this.scenario_slug])
                .then((response) => {
                    self.room_sessions = response.data;
                    self.latest_room_session = self.room_sessions.shift();
                });
        }
    }
}
</script>